package ui.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.dom.ContentBuilder
import org.jetbrains.compose.web.dom.TagElement
import org.w3c.dom.HTMLElement

@Composable
fun M3FilledButton(
    attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null,
    content: ContentBuilder<HTMLElement>? = null
) {
    TagElement(
        tagName = "md-filled-button",
        applyAttrs = {
            classes("dark:text-white") // Fuerzo el color del texto blanco en M3FilledButton
            attrs?.invoke(this)
        },
        content = content
    )
}

@Composable
fun M3TextButton(
    attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null,
    content: ContentBuilder<HTMLElement>? = null
) {
    TagElement(
        tagName = "md-text-button",
        applyAttrs = attrs,
        content = content
    )
}

@Composable
fun M3OutlinedButton(
    attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null,
    content: ContentBuilder<HTMLElement>? = null
) {
    TagElement(
        tagName = "md-outlined-button",
        applyAttrs = {
            classes("dark:border-medical-primaryDark", "dark:text-white") // Borde del color principal dark y texto blanco
            attrs?.invoke(this)
        },
        content = content
    )
}

@Composable
fun M3Icon(
    iconName: String,
    attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null
) {
    TagElement(
        tagName = "md-icon",
        applyAttrs = attrs,
        content = {
            org.jetbrains.compose.web.dom.Text(iconName)
        }
    )
}
